import axios from 'axios';
import { auth } from '../firebase';

const authToken = async () => {
    try {
        return await auth.currentUser.getIdToken();
    } catch (error) {
        // Specific token error handling
        if (error.code === 'auth/network-request-failed') {
            throw new Error('Network error - please check your connection');
        }
        if (error.code === 'auth/user-token-expired') {
            throw new Error('Session expired - please log in again');
        }
        // Force logout on unrecoverable auth errors
        if (error.code === 'auth/invalid-user-token' || error.code === 'auth/user-disabled') {
            auth.signOut();
            throw new Error('Authentication invalid - logging out');
        }
        // Re-throw original error for other cases
        throw error;
    }
};

export default {
    getUserByEmail: async (email) => {
        return await axios.get(`/api/admin/email/${email}`);
    },

    decryptBsPassword: async (obj) => {
        return await axios.post('/api/admin/decrypt', obj);
    },
    
    uploadCodesToAirtable: async (data) => {
        return await authToken().then(async token => {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            };
    
            return await axios.post(`/api/admin/airtable`, data, config);
        });
    },
    
    completeBSEntAccount: async (obj) => {
        return await authToken().then(async token => {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            };

            return await axios.post(`/api/admin/bsent`, obj, config);
        });
    },

    getConfigDocs: async () => {
        try {
            return await axios.get('/api/admin/configDocs');
        } catch (err) {
            console.error(err);
        };
    },

    getProducts: async () => {
        try {
            return await axios.get('/api/admin/products');
        } catch (error) {
            console.error("Error getting products: ", error.message);
            throw error;
        };
    },

    initializeRetailCode: async (id) => {
        try {
            return await axios.post('/api/admin/retail-codes/initialize', { id });
        } catch (error) {
            console.error('Error initializing retail code: ', error.message);
            throw error;
        }
    },

    listStagedRetailCodes: async () => {
        try {
            return await axios.get('/api/admin/retail-codes');
        } catch (error) {
            console.error('Error listing staged retail codes: ', error.message);
            throw error;
        }
    },

    createOrg: async (data) => {
        try {
            const token = await authToken();
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await axios.post(`/api/org/create`, data, config);
            // If server indicates claims were updated, force refresh of ID token
            if (response?.data?.requiresTokenRefresh) {
                try {
                    await auth.currentUser.getIdToken(true);
                } catch (e) {
                    console.error('adminAPI: createOrg: Failed to refresh ID token after claims update:', e?.message || e);
                }
            }
            return response.data;
        } catch (error) {
            console.error("adminAPI createOrg error: ", error.message);
            throw error;
        }
    },
};
